// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMermaid-modulediagram__laPO0";
var _2 = "GretaAIChatMermaid-moduleerror__zfLYM";
var _3 = "GretaAIChatMermaid-modulefallback__pENua";
var _4 = "GretaAIChatMermaid-modulefallbackSource__v1GnL GretaAIChatCodeBlock-modulecodeBlock__JUw6b";
export { _1 as "diagram", _2 as "error", _3 as "fallback", _4 as "fallbackSource" }
